import React from "react";

export default function Banner({ banner }) {
  const cls = "banner" + (banner.show ? " show" : "") + (banner.isError ? " error" : "");
  return (
    <div className={cls} data-testid="banner">
      {banner.msg}
    </div>
  );
}
